import Permissoes from "@/utils/permissoes";
 import { formMode } from "@/utils/form.helpers";

const routes = [
  {
    path: "/roteirizacao",
    name: "roteirizacao",
    component: () => import("@/views/roteirizacao/index.vue"),
    meta: {
      title: "Roteirização",
      authRequired: true,
      permissoes: [Permissoes.Roteirizacao],
      menus: [Permissoes.Roteirizacao]
    },
  },
  {
    path: "/roteirizacao/nova-roteirizacao",
    name: "roteirizacao-nova-roteirizacao",
    component: () => import("@/views/roteirizacao/form.vue"),
    meta: {
      title: "Roteirização - Nova Roteirização",
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.NovaRoteirizacao],
      menus: [Permissoes.Roteirizacao]
    },
  }  ,
  {
    path: "/roteirizacao/editar-roteirizacao",
    name: "roteirizacao-editar-roteirizacao",
    component: () => import("@/views/roteirizacao/form.vue"),
    meta: {
      title: "Roteirização - Editar Roteirização",
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.EditarRoteirizacao],
      menus: [Permissoes.Roteirizacao]
    },
  }
];
export default routes;
